// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__1oWL8","column":"style_column__2lnIt","row":"style_row__3jZyT"};